export default __webpack_public_path__ + "static/media/IconSearch.b8bcc0e0.svg";